import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getRootStore } from "@/stores/RootStore";
import styles from "@/styles/OtpVerification.module.less";
import { ClockCircleOutlined, MailOutlined, PhoneOutlined, } from "@ant-design/icons";
import { Alert, Button, Form, Input, Space, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
const { Title, Text } = Typography;
const OtpVerification = observer(({ onBack, method, email, phone }) => {
    const { authStore } = getRootStore();
    const [form] = Form.useForm();
    const [countdown, setCountdown] = useState(60);
    const [canResend, setCanResend] = useState(false);
    useEffect(() => {
        if (countdown > 0) {
            const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
            return () => clearTimeout(timer);
        }
        else {
            setCanResend(true);
        }
    }, [countdown]);
    const handleSubmit = async (values) => {
        const currentMethod = method || authStore.otpMethod;
        const currentEmail = email || authStore.pendingEmail;
        const currentPhone = phone || authStore.pendingPhone;
        const credentials = {
            token: values.otp,
            type: currentMethod,
            email: currentMethod === "email" ? currentEmail : undefined,
            phone: currentMethod === "phone" ? currentPhone : undefined,
        };
        await authStore.verifyOtp(credentials);
    };
    const handleResend = async () => {
        const success = await authStore.resendOtp();
        if (success) {
            setCountdown(60);
            setCanResend(false);
        }
    };
    const getContactInfo = () => {
        const currentMethod = method || authStore.otpMethod;
        const currentEmail = email || authStore.pendingEmail;
        const currentPhone = phone || authStore.pendingPhone;
        if (currentMethod === "email") {
            return {
                icon: _jsx(MailOutlined, {}),
                contact: currentEmail,
                label: "email",
            };
        }
        else {
            return {
                icon: _jsx(PhoneOutlined, {}),
                contact: currentPhone,
                label: "телефон",
            };
        }
    };
    const contactInfo = getContactInfo();
    return (_jsxs("div", { className: styles.authForm, children: [_jsx(Title, { level: 3, className: styles.title, children: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F" }), _jsx("div", { className: styles.otpInfo, children: _jsxs(Space, { children: [contactInfo.icon, _jsxs(Text, { children: ["\u041A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u043D\u0430 ", contactInfo.label, ":", " ", _jsx("strong", { children: contactInfo.contact })] })] }) }), _jsxs(Form, { form: form, name: "otp-verification", onFinish: handleSubmit, autoComplete: "off", layout: "vertical", size: "large", children: [_jsx(Form.Item, { name: "otp", label: "\u041A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F", rules: [
                            { required: true, message: "Пожалуйста, введите код!" },
                            { len: 6, message: "Код должен содержать 6 цифр!" },
                            {
                                pattern: /^\d+$/,
                                message: "Код должен содержать только цифры!",
                            },
                        ], children: _jsx(Input, { placeholder: "000000", maxLength: 6, style: {
                                textAlign: "center",
                                fontSize: "18px",
                                letterSpacing: "4px",
                            } }) }), authStore.authError && (_jsx(Form.Item, { children: _jsx(Alert, { message: authStore.authError, type: "error", showIcon: true, closable: true, onClose: () => authStore.setAuthError(null) }) })), _jsx(Form.Item, { children: _jsx(Button, { type: "primary", htmlType: "submit", loading: authStore.isLoading, block: true, children: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C" }) }), _jsx(Form.Item, { children: _jsxs(Space, { direction: "vertical", style: { width: "100%", textAlign: "center" }, children: [!canResend ? (_jsxs(Text, { type: "secondary", children: [_jsx(ClockCircleOutlined, {}), " \u041F\u043E\u0432\u0442\u043E\u0440\u043D\u0430\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430 \u0447\u0435\u0440\u0435\u0437 ", countdown, " ", "\u0441\u0435\u043A"] })) : (_jsx(Button, { type: "link", onClick: handleResend, loading: authStore.isLoading, children: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E" })), _jsx(Button, { type: "link", onClick: onBack, disabled: authStore.isLoading, children: "\u041D\u0430\u0437\u0430\u0434" })] }) })] })] }));
});
export default OtpVerification;
